import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StockService } from '../../../../services/stock.service';
import { Stock } from '../../../../models/Stock';

@Component({
  selector: 'app-stock-view',
  templateUrl: './stock-view.component.html',
  styleUrls: ['./stock-view.component.css']
})
export class StockViewComponent implements OnInit {
  stock: Stock | null = null;
  isLoading = false;
  stockId?: number;
  showWarehouseModal = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private stockService: StockService
  ) {}

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.stockId = Number(idParam);
      this.loadStock();
    } else {
      this.router.navigate(['/stock/inventory']);
    }
  }

  loadStock(): void {
    if (!this.stockId) return;
    
    this.isLoading = true;
    this.stockService.getById(this.stockId).subscribe({
      next: stock => {
        this.stock = stock;
        this.isLoading = false;
      },
      error: _ => {
        this.isLoading = false;
        this.router.navigate(['/stock/inventory']);
      }
    });
  }

  edit(): void {
    if (this.stockId) {
      this.router.navigate(['/stock/inventory', this.stockId, 'edit']);
    }
  }

  back(): void {
    this.router.navigate(['/stock/inventory']);
  }

  getStatusBadgeClass(status: string): string {
    switch (status?.toLowerCase()) {
      case 'ativo':
        return 'badge bg-success';
      case 'inativo':
        return 'badge bg-secondary';
      case 'bloqueado':
        return 'badge bg-danger';
      case 'manutenção':
        return 'badge bg-warning';
      default:
        return 'badge bg-primary';
    }
  }

  getQuantityStatusClass(stock: Stock): string {
    if (!stock.minimumQuantity) return '';
    
    if (stock.currentQuantity <= 0) {
      return 'text-danger fw-bold';
    } else if (stock.currentQuantity <= stock.minimumQuantity) {
      return 'text-warning fw-bold';
    }
    return 'text-success';
  }

  getQuantityStatusText(stock: Stock): string {
    if (!stock.minimumQuantity) return '';
    
    if (stock.currentQuantity <= 0) {
      return 'Sem estoque';
    } else if (stock.currentQuantity <= stock.minimumQuantity) {
      return 'Estoque baixo';
    }
    return 'Estoque normal';
  }

  formatDate(dateString?: string): string {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('pt-BR');
  }

  formatCurrency(value?: number, currencyCode?: string): string {
    if (!value) return '-';
    const currency = currencyCode || 'BRL';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: currency
    }).format(value);
  }

  manageWarehouse(): void {
    this.showWarehouseModal = true;
  }

  closeWarehouseModal(): void {
    this.showWarehouseModal = false;
  }

  onWarehouseOperationSuccess(): void {
    this.loadStock(); // Recarregar os dados do estoque
  }
}
